<i18n src="@/locales/views/organization/certifications/query_formats/list_formats.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('list_certifications')"
    :params="{
     organization_id: organizationId,
    }"
  ></go-back-link>
  <bread-crumbs :labels="[module_name, certification_version.certification?.name, certification_version.name]" />

  <template v-if="load_data_general">
    <div v-if="certification_formats.length > 0" class="bg-white shadow overflow-hidden sm:rounded-md" >
      <ul role="list" class="divide-y divide-gray-200">
        <li v-for="certification_format in certification_formats" :key="certification_format.id">
          <div class="block hover:bg-gray-50 cursor-pointer" @click.prevent="goToShow(certification_format.id)">
            <div class="px-4 py-4 sm:px-6">
              <div class="flex items-center justify-between">
                <p class="text-sm font-medium text-gray-900 truncate">
                  {{ certification_format.name }}
                </p>
                <div class="ml-2 flex-shrink-0 flex">
                  <a class="link invisible sm:visible">
                    <i class="fa-solid fa-eye"></i>
                    <span class="space-icon"></span>{{ $t("labels.show_link") }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <p v-else> {{ $t('labels.no_formats') }} </p>
  </template>

  <loading-message v-else />

</template>

<script>
import Requester from "@/views/organization/requesters/certifications/query_formats/list_formats.js";

export default {
  name: "AECertificationsQueryFormatsListFormats",
  data() {
    return {
      load_data_general: false,
      certification_version: {},
      certification_formats: [],
    };
  },
  props: {
    organizationId: { required: true },
    certificationId: { required: true },
    certificationVersionId: { required: true }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organizationId,
        },
      }).then(() => this.loadData())
    );
  },
  methods: {
    loadData: async function () {
      await this.fetchCertificationVersion();
      await this.fetchCertificationFormats();
      this.load_data_general = true;
    },
    fetchCertificationVersion: async function () {
      let response = await Requester.fetchCertificationVersion({
        organization_id: this.organizationId,
        certification_id: this.certificationId,
        certification_version_id: this.certificationVersionId
      });

      this.certification_version = response.data;
    },
    fetchCertificationFormats: async function () {
      let response = await Requester.fetchCertificationFormats({
        organization_id: this.organizationId,
        certification_id: this.certificationId,
        certification_version_id: this.certificationVersionId
      });

      this.certification_formats = response.data;
    },
    goToShow(formatCertificationId) {
      this.$router.push({
        name: this.routeName("list_producers"),
        params: {
          organization_id: this.organizationId,
          certificationId: this.certificationId,
          versionId: this.certificationVersionId,
          formatCertificationId
        },
      });
    },
  },
};
</script>
